import React, { useState, useEffect, useRef, useContext } from 'react';
import './Dashboard.css';
import ReactDOM from 'react-dom';

//import HeaderBar from '../../components/HeaderBar/';
//import SideBarNavigation from '../../components/SideBarNavigation/';
//import DelayedLoadingMessage from '../../components/DelayedLoadingMessage/';
import DelayedSelect from '../../components/DelayedSelect/';
import GraphCard from '../../components/GraphCard/';
//import Grid from "@material-ui/core/Grid";
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
//import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
//import Card from '@material-ui/core/Card';
import {
  MuiThemeProvider,
  AppBar,
  Toolbar,
  FormControl,
  Typography,
  Menu,
  MenuItem,
  Tooltip,
  Switch,
  CssBaseline,
  Divider,
} from '@material-ui/core';
//import { debounce } from "debounce";
//import GridList from '@material-ui/core/GridList';
import Fade from '@material-ui/core/Fade';
//import FadeIn from 'react-fade-in';
import LinearProgress from '@material-ui/core/LinearProgress';
import CustomMsgToast from '../../components/CustomMsgToast/';
import LoggedOutToast from '../../components/LoggedOutToast/';
import AnnouncementBar from '../../components/AnnouncementBar/';

import SettingsIcon from '@mui/icons-material/Settings';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import FlipToBackIcon from '@mui/icons-material/FlipToBack';
import FlipToFrontIcon from '@mui/icons-material/FlipToFront';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
//import DateFnsUtils from '@date-io/date-fns';
//import { MuiPickersUtilsProvider, InlineDatePicker } from 'material-ui-pickers';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import AddCustomCard from './components/AddCustomCard';
import { Screen } from '../../components';

import { ThemeContext, ThemeProvider } from '../../lib/contexts/ThemeContext';

import useMetric from '../../lib/hooks/useMetric';

import { GridContextProvider, GridDropZone, GridItem, swap, move } from 'react-grid-dnd';
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import { PARTNER_TUTORIAL } from '../../lib/constants/tutorials';
import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#1e8555', secondary: '#f5f5f5' },
  },
  typography: {
    useNextVariants: true,
    fontFamily: '"Raleway", "Helvetica", "Arial", sans-serif',
  },
});

const styles = (theme) => ({
  root: {
    display: 'flex',
    overflowX: 'hidden',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: '#f5f5f5',
  },
  drawerText: {
    color: 'white',
    padding: 0,
  },
  content: {
    flexGrow: 1,
    padding: `${theme.spacing.unit * 2} px`,
    marginLeft: 15,
    marginRight: 25,
    overflowX: 'hidden',
  },
  toolbar: theme.mixins.toolbar,
  contactCard: {
    height: 400,
    width: '100%',
    padding: 20,
  },

  avatar: {
    color: '#fff',
    backgroundColor: green[700],
    display: 'inline-flex',
  },
  searchBox: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 18,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    },
    justifyContent: 'space-between',
    margin: '0 auto',
  },
  detailTable: {},
  gridList: {
    flexWrap: 'nowrap',
    transform: 'translateZ(0)',
  },
  dropzone: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  gridItem: {
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
    },
  },
  formControl: {
    width: '25%',
    marginTop: -5,
    marginLeft: '2.5%',
    [theme.breakpoints.down('sm')]: {
      marginRight: '24%',
    },
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
    },
  },
});

const getCookie = (cookieKey) => {
  let cookieName = `${cookieKey}=`;
  let cookieArray = document.cookie.split(';');
  for (let cookie of cookieArray) {
    while (cookie.charAt(0) == ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(cookieName) == 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
};

const MetricDashboardScreen = (props) => {
  const [state, setState] = useState({
    user_id: props.user_id,
    impersonating: props.impersonating,
    time_span: document.cookie.indexOf('time_span=') >= 0 ? getCookie('time_span') : 'today',
    start_time_span: new Date(new Date() - 14 * 86400000).toISOString().slice(0, 10),
    end_time_span: new Date().toISOString().slice(0, 10),
    location: 'all',
    provider: 'all',
    anchorElMoreMenu: null,
    ForceCloseMenu: null,
    anchorEl: null,
    expandedMode: false,
    graph_layout_mode: document.cookie.indexOf('graph_layout_mode=') >= 0 ? true : false,
    tutorial_run: document.cookie.indexOf('tutorial_3=') >= 0 ? false : true,
    auto_refresh: document.cookie.indexOf('refresh=') >= 0 ? true : false,
    refresh_timer: 300,
    auto_refresh_popup: false,
    graphs_enabled: true,
    item_options: [
      { type: 'roi_combined', icon: 'MonetizationOn', title: 'Revenue Generated', lines: 'double' },
      { type: 'roi_fiat', icon: 'MonetizationOn', title: 'Revenue Generated' },
      { type: 'roi_percent', icon: 'MonetizationOn', title: 'Return on Investment' },
      { type: 'average_wait_skipped', icon: 'History', title: 'Average Wait Time Skipped by Patient' },
      { type: 'median_fill_time', icon: 'Beenhere', title: 'Median Fill Time' },
      { type: 'filled_appointments', icon: 'EventAvailable', title: 'Filled Appointments' },
      { type: 'patients_texted', icon: 'PermPhoneMsgIcon', title: 'Phone Calls Saved' },
      { type: 'bumps_rescheduled_count', icon: 'AssignmentTurnedIn', title: 'Bumps Rescheduled' },
      { type: 'no_shows_rescheduled_count', icon: 'AssignmentTurnedIn', title: 'No-shows Rescheduled' },
      { type: 'total_cancellations', icon: 'EventAvailable', title: 'Total Cancellations' },
      { type: 'queuedr_unsubscribes', icon: 'AlarmOff', title: 'Unsubscribes' },
      { type: 'cancellations_texted', icon: 'TextSMS', title: 'Cancellations Texted' },
      { type: 'no_shows_texted', icon: 'TextSMS', title: 'No-shows Texted' },
      { type: 'bumps_texted', icon: 'TextSMS', title: 'Bumps Texted' },
      { type: 'active_appointment_types', icon: 'Ballot', title: 'Active Appointment Types' },
      {
        type: 'active_providers',
        icon: 'SupervisorAccountIcon',
        title: 'Active Providers',
        alert: 'Please contact Support to activate more Providers.',
      },
      { type: 'total_providers', icon: 'SupervisorAccountIcon', title: 'Total Providers' },
      { type: 'total_accounts', icon: 'Work', title: 'Total User Accounts' },
      { type: 'reminders_rescheduled_count', icon: 'AssignmentTurnedIn', title: 'Reminder Rescheduled' },
      { type: 'fills_by_type', icon: 'AssignmentTurnedIn', title: 'Fills by Product' },
      { type: 'stats_by_provider', icon: 'AssignmentTurnedIn', title: 'Number of Fills by Provider' },
      { type: 'stats_by_location', icon: 'AssignmentTurnedIn', title: 'Number of Fills by Location' },
      { type: 'stats_by_appointment_type', icon: 'AssignmentTurnedIn', title: 'Number of Fills by Appointment Types' },
      { type: 'schedule_balancing_stats', icon: 'AssignmentTurnedIn', title: 'Schedule Balancing Stats' },
      {
        type: 'top_appointment_types_to_add',
        icon: 'AssignmentTurnedIn',
        title: 'Top 5 Appointment Types to Add',
        alert: 'Please contact Support to activate more Appointment Types.',
      },
      {
        type: 'top_providers_to_add',
        icon: 'AssignmentTurnedIn',
        title: 'Top 5 Providers to Add',
        alert: 'Please contact Support to activate more Providers.',
      },
      { type: 'top_cancelled_appointment_time', icon: 'AssignmentTurnedIn', title: 'Most Cancelled Appointment Time' },
      { type: 'top_cancelled_appointment_day', icon: 'AssignmentTurnedIn', title: 'Most Cancelled Appointment Day' },
      {
        type: 'top_booked_provider',
        icon: 'AssignmentTurnedIn',
        title: 'Top 5 Booked Providers',
        alert: 'Showing Top 5.',
      },
      {
        type: 'top_booked_appointment_type',
        icon: 'AssignmentTurnedIn',
        title: 'Top 5 Booked Appointment Types',
        alert: 'Showing Top 5.',
      },
    ],
    items: {
      top: [
        { type: 'roi_combined', icon: 'MonetizationOn', title: 'Revenue Generated', lines: 'double' },
        { type: 'roi_fiat', icon: 'MonetizationOn', title: 'Revenue Generated' },
        { type: 'roi_percent', icon: 'MonetizationOn', title: 'Return on Investment' },
        { type: 'average_wait_skipped', icon: 'History', title: 'Average Wait Time Skipped by Patient' },
        { type: 'median_fill_time', icon: 'Beenhere', title: 'Median Fill Time' },
        { type: 'filled_appointments', icon: 'EventAvailable', title: 'Filled Appointments' },
        { type: 'patients_texted', icon: 'PermPhoneMsgIcon', title: 'Phone Calls Saved' },
        { type: 'bumps_rescheduled_count', icon: 'AssignmentTurnedIn', title: 'Bumps Rescheduled' },
        { type: 'no_shows_rescheduled_count', icon: 'AssignmentTurnedIn', title: 'No-shows Rescheduled' },
        { type: 'total_cancellations', icon: 'EventAvailable', title: 'Total Cancellations' },
        { type: 'queuedr_unsubscribes', icon: 'AlarmOff', title: 'Unsubscribes' },
        { type: 'cancellations_texted', icon: 'TextSMS', title: 'Cancellations Texted' },
        { type: 'no_shows_texted', icon: 'TextSMS', title: 'No-shows Texted' },
        { type: 'bumps_texted', icon: 'TextSMS', title: 'Bumps Texted' },
        { type: 'active_appointment_types', icon: 'Ballot', title: 'Active Appointment Types' },
        {
          type: 'active_providers',
          icon: 'SupervisorAccountIcon',
          title: 'Active Providers',
          alert: 'Please contact Support to activate more Providers.',
        },
        { type: 'total_providers', icon: 'SupervisorAccountIcon', title: 'Total Providers' },
        { type: 'total_accounts', icon: 'Work', title: 'Total User Accounts' },
        { type: 'reminders_rescheduled_count', icon: 'AssignmentTurnedIn', title: 'Reminder Rescheduled' },
      ],
      bottom: [
        { type: 'fills_by_type', icon: 'AssignmentTurnedIn', title: 'Fills by Product' },
        { type: 'stats_by_provider', icon: 'AssignmentTurnedIn', title: 'Number of Fills by Provider' },
        { type: 'stats_by_location', icon: 'AssignmentTurnedIn', title: 'Number of Fills by Location' },
        {
          type: 'stats_by_appointment_type',
          icon: 'AssignmentTurnedIn',
          title: 'Number of Fills by Appointment Types',
        },
        { type: 'schedule_balancing_stats', icon: 'AssignmentTurnedIn', title: 'Schedule Balancing Stats' },
        {
          type: 'top_appointment_types_to_add',
          icon: 'AssignmentTurnedIn',
          title: 'Top 5 Appointment Types to Add',
          alert: 'Please contact Support to activate more Appointment Types.',
        },
        {
          type: 'top_providers_to_add',
          icon: 'AssignmentTurnedIn',
          title: 'Top 5 Providers to Add',
          alert: 'Please contact Support to activate more Providers.',
        },
        {
          type: 'top_cancelled_appointment_time',
          icon: 'AssignmentTurnedIn',
          title: 'Most Cancelled Appointment Time',
        },
        { type: 'top_cancelled_appointment_day', icon: 'AssignmentTurnedIn', title: 'Most Cancelled Appointment Day' },
        {
          type: 'top_booked_provider',
          icon: 'AssignmentTurnedIn',
          title: 'Top 5 Booked Providers',
          alert: 'Showing Top 5.',
        },
        {
          type: 'top_booked_appointment_type',
          icon: 'AssignmentTurnedIn',
          title: 'Top 5 Booked Appointment Types',
          alert: 'Showing Top 5.',
        },
      ],
    },
    tutorial_stepIndex: 0,
    tutorial_steps: PARTNER_TUTORIAL,
    showProvidersAndLocations: false,
  });
  const {
    state: { finalTheme },
  } = useContext(ThemeContext);
  // console.log('here is useMetric hook', useMetric('Revenue Generated'));

  // Create refs using useRef
  const inputLabelRef = useRef(null);
  const inputLabelRef2 = useRef(null);
  const inputLabelRef3 = useRef(null);
  const inputLabelRef4 = useRef(null);

  useEffect(() => {
    loadDashboardData();
    betaUnlocker();
  }, []);

  const betaUnlocker = () => {
    let pressed = {};
    document.addEventListener('keydown', (event) => {
      pressed[event.key] = true;
    });
    document.addEventListener('keyup', (event) => {
      delete pressed[event.key];
    });
    document.addEventListener('keydown', (event) => {
      if (pressed['ArrowLeft'] && pressed['ArrowRight'] && event.shiftKey) {
        alert('Beta Unlocked');
        // setState(prevState => ({ ...prevState, graphs_enabled: true })); // Uncomment to enable graphs
      }
    });
  };

  const loadDashboardData = () => {
    const apiURL = '/metrics';
    fetch(apiURL, { cache: 'no-store' })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.api) {
          const data = responseJson.api;
          const options = state.item_options;
          const top = data.filter((t) => t.placement.includes('top'));
          const bottom = data.filter((t) => t.placement.includes('bottom'));

          const filtered_top = top.map((item) => {
            let item2 = options.find((i2) => i2.type === item.type);
            return item2 ? { ...item, ...item2 } : item;
          });
          const filtered_bottom = bottom.map((item) => {
            let item2 = options.find((i2) => i2.type === item.type);
            return item2 ? { ...item, ...item2 } : item;
          });
          const items = {
            top: filtered_top,
            bottom: filtered_bottom,
          };
          setState((prevState) => ({ ...prevState, items: items }));
        } else {
          setState((prevState) => ({ ...prevState, logged_out: true }));
        }
      })
      .catch((error) => {
        setState((prevState) => ({ ...prevState, logged_out: true }));
        console.error(error);
      });
  };
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobile]);

  const updateContentSize = (a) => {
    setState((prevState) => ({ ...prevState, expandedMode: a }));
  };

  const onChange = (sourceId, sourceIndex, targetIndex, targetId) => {
    let items = state.items;
    if (sourceId) {
      if (targetId) {
        if (targetId !== 'top' || (targetId === 'top' && items[targetId].length < 5)) {
          const result = move(items[sourceId], items[targetId], sourceIndex, targetIndex);
          items[sourceId] = result[0];
          items[targetId] = result[1];
          setState((prevState) => ({ ...prevState, items: items }));
        }
      }

      const nextState = swap(items[sourceId], sourceIndex, targetIndex);
      items[sourceId] = nextState;
      setState((prevState) => ({ ...prevState, items: items }));

      const item_id = items[sourceId][targetIndex].id;
      const apiURL = 'api/dashboard_v2/metric/reorder/' + item_id + '/' + sourceId + '/' + (targetIndex + 1);
      // console.log(apiURL);
      fetch(apiURL, { cache: 'no-store' })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.data.message === 'Saved') {
            // Handle success
          } else {
            // Handle logged out
          }
        })
        .catch((error) => {
          setState((prevState) => ({ ...prevState, logged_out: true }));
          console.error(error);
        });
    }
  };

  const handleTimeMenuClick = (event) => {
    setState((prevState) => ({ ...prevState, anchorEl: event.currentTarget }));
  };

  const handleTimeMenuClose = (time) => (e) => {
    setState((prevState) => ({ ...prevState, anchorEl: null }));
    if (time) {
      setState((prevState) => ({ ...prevState, time_span: time }));
      const date = new Date();
      date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
      document.cookie = 'time_span=' + time + '; expires=' + date.toGMTString() + '; path=/';
    }
  };

  const closeAllMenus = () => {
    setState((prevState) => ({ ...prevState, anchorEl: null, anchorElMoreMenu: null }));
  };

  const goFullScreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      if (!state.expandedMode) {
        setState((prevState) => ({ ...prevState, ForceToggle: 'toggle' }));
        setTimeout(() => {
          setState((prevState) => ({ ...prevState, ForceToggle: null }));
        }, 3000);
        setState((prevState) => ({ ...prevState, expandedMode: !state.expandedMode }));
      }
      document.documentElement.requestFullscreen();
    }
  };

  const toggleGraphLayout = () => {
    setState((prevState) => ({ ...prevState, graph_layout_mode: !state.graph_layout_mode }));
    if (!state.graph_layout_mode) {
      const date = new Date();
      date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
      document.cookie = 'graph_layout_mode=true; expires=' + date.toGMTString() + '; path=/';

      if (window.innerWidth < 1024) {
        if (!state.expandedMode) {
          setState((prevState) => ({ ...prevState, ForceToggle: 'toggle' }));
          setTimeout(() => {
            setState((prevState) => ({ ...prevState, ForceToggle: null }));
          }, 3000);
          setState((prevState) => ({ ...prevState, expandedMode: !state.expandedMode }));
        }
      }
    } else {
      document.cookie = 'graph_layout_mode=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    }
  };

  const passUp = (loc, v) => {
    if (loc === 'providers') {
      setState((prevState) => ({ ...prevState, provider: v }));
    }
    if (loc === 'locations') {
      setState((prevState) => ({ ...prevState, location: v }));
    }
    if (loc === 'logged_out') {
      setState((prevState) => ({ ...prevState, logged_out: true }));
    }
  };

  const toggleAutoRefresh = () => {
    setState((prevState) => ({ ...prevState, auto_refresh: !state.auto_refresh }));
    if (state.time_span !== 'today') {
      setState((prevState) => ({ ...prevState, auto_refresh_popup: true }));
    }
    if (!state.auto_refresh) {
      const date = new Date();
      date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
      document.cookie = 'refresh=true; expires=' + date.toGMTString() + '; path=/';
    } else {
      document.cookie = 'refresh=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    }
  };

  const handleDateChange = (val, typ) => {
    let dd = val.getDate();
    let mm = val.getMonth() + 1;
    let yyyy = val.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    val = yyyy + '-' + mm + '-' + dd;
    if (typ === 'end') {
      setState((prevState) => ({ ...prevState, end_time_span: val }));
    } else {
      setState((prevState) => ({ ...prevState, start_time_span: val }));
    }
  };

  const handleJoyrideCallback = (data) => {
    const { action, index, type } = data;

    if (action === 'close' || action === 'skip' || type === 'tour:end') {
      setState((prevState) => ({ ...prevState, tutorial_run: false, tutorial_stepIndex: 0 }));
      const days = 365;
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = '; expires=' + date.toGMTString();
      document.cookie = 'tutorial_3=true' + expires + '; path=/';
    } else if (type === 'step:after') {
      const tutorial_stepIndex = index + (action === ACTIONS.PREV ? -1 : 1);
      setState((prevState) => ({ ...prevState, tutorial_stepIndex: tutorial_stepIndex }));
    }
  };

  const removeCard = (type, id) => {
    if (id && type) {
      const apiURL = '/api/dashboard_v2/metric/remove/' + id;
      fetch(apiURL, { cache: 'no-store' })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.data.message === 'Removed') {
            let items = state.items;
            items.top = items.top.filter((t) => !t.type.includes(type));
            items.bottom = items.bottom.filter((t) => !t.type.includes(type));
            setState((prevState) => ({ ...prevState, items: items }));

            // if (items.top.length === 0 && items.bottom.length === 0) {
            //     console.log('Refresh to generate default cards');
            // }
          } else {
            // Handle logged out
          }
        })
        .catch((error) => {
          setState((prevState) => ({ ...prevState, logged_out: true }));
          console.error(error);
        });
    }
  };

  const handleOpenMoreMenuClick = (event) => {
    setState((prevState) => ({ ...prevState, anchorElMoreMenu: event.currentTarget }));
  };

  const resetLayout = () => {
    const apiURL = '/api/dashboard_v2/reset/';
    fetch(apiURL, { cache: 'no-store' })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.data.message === 'Reset') {
          closeAllMenus();
          loadDashboardData();
        } else {
          setState((prevState) => ({ ...prevState, logged_out: true }));
        }
      })
      .catch((error) => {
        setState((prevState) => ({ ...prevState, logged_out: true }));
        console.error(error);
      });
  };

  const { classes } = props;
  const {
    user_id,
    impersonating,
    graphs_enabled,
    graph_layout_mode,
    items,
    tutorial_run,
    tutorial_steps,
    tutorial_stepIndex,
    expandedMode,
    anchorEl,
    ForceToggle,
    time_span,
    start_time_span,
    end_time_span,
    location,
    provider,
    auto_refresh,
    logged_out,
    refresh_timer,
    anchorElMoreMenu,
  } = state;
  const time_span_pretty = time_span
    .split('_')
    .join(' ')
    .toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');

  const timePickerStart = new Date(start_time_span).toLocaleString('en-US', { timeZone: 'UTC' });
  const timePickerStartMax = new Date(end_time_span).toLocaleString('en-US', { timeZone: 'UTC' });
  const timePickerEnd = new Date(end_time_span).toLocaleString('en-US', { timeZone: 'UTC' });
  const timePickerEndMin = new Date(start_time_span).toLocaleString('en-US', { timeZone: 'UTC' });
  const timePickerEndMax = new Date(new Date().toISOString().slice(0, 10)).toLocaleString('en-US', { timeZone: 'UTC' });

  return (
    <MuiThemeProvider theme={finalTheme}>
      <Screen
        title={'Metrics'}
        showSidebarNav={true}
        admin={true}
        id={'metrics'}
      >
        <MuiThemeProvider
          theme={theme}
          className={classes.root}
        >
          <main
            id={'metrics_main'}
            className={expandedMode ? classes.content + ' pageContent expanded' : classes.content + ' pageContent'}
          >
            <AppBar
              position="relative"
              style={{
                backgroundColor: finalTheme.palette.background.default,
                borderBottomLeftRadius: 5,
                borderBottomRightRadius: 5,
              }}
            >
              <Toolbar>
                <Joyride
                  run={tutorial_run}
                  stepIndex={tutorial_stepIndex}
                  steps={tutorial_steps}
                  showProgress={true}
                  disableScrolling={true}
                  continuous={true}
                  showSkipButton={true}
                  callback={handleJoyrideCallback}
                />
                <div className={classes.searchBox}>
                  <FormControl
                    className={'patient_search_box'}
                    style={{ width: '20%', margin: 'auto', marginLeft: '2.5%' }}
                  >
                    <Typography
                      variant="h5"
                      component="h2"
                      style={{ fontSize: 24, color: finalTheme.palette.text.primary }}
                    >
                      Reporting
                    </Typography>
                    <Typography
                      color="textSecondary"
                      className={'time_span_option'}
                      gutterBottom
                      onClick={handleTimeMenuClick}
                      style={{ cursor: 'pointer', color: finalTheme.palette.text.secondary }}
                    >
                      {time_span_pretty}'s Stats {!anchorEl ? <>&#x25BC;</> : <>&#x25B2;</>}
                    </Typography>
                    <Menu
                      id="fade-menu"
                      anchorEl={anchorEl}
                      open={anchorEl != null ? true : false}
                      onClose={closeAllMenus}
                      style={{ marginTop: 50 }}
                    >
                      <MenuItem onClick={handleTimeMenuClose('today')}>Today</MenuItem>
                      <MenuItem onClick={handleTimeMenuClose('last_week')}>Last Week</MenuItem>
                      <MenuItem onClick={handleTimeMenuClose('last_month')}>Last Month</MenuItem>
                      <MenuItem onClick={handleTimeMenuClose('all_time')}>All Time</MenuItem>
                      <MenuItem onClick={handleTimeMenuClose('custom')}>Custom Range</MenuItem>
                    </Menu>
                  </FormControl>
                  {state.showProvidersAndLocations && (
                    <>
                      <FormControl
                        className={'patient_search_filter providerTools'}
                        variant="outlined"
                        fullWidth={true}
                        classes={{ root: classes.formControl }}
                      >
                        <InputLabel
                          ref={inputLabelRef}
                          htmlFor="outlined-age-native-simple"
                          style={{ color: finalTheme.palette.text.primary }}
                        >
                          Providers
                        </InputLabel>
                        <DelayedSelect
                          type={'providers'}
                          passUp={passUp}
                        />
                      </FormControl>
                      <FormControl
                        className={'patient_search_filter locationTools'}
                        variant="outlined"
                        fullWidth={true}
                        classes={{ root: classes.formControl }}
                      >
                        <InputLabel
                          ref={inputLabelRef2}
                          htmlFor="outlined-age-native-simple"
                          style={{ color: finalTheme.palette.text.primary }}
                        >
                          Locations
                        </InputLabel>
                        <DelayedSelect
                          type={'locations'}
                          passUp={passUp}
                        />
                      </FormControl>
                    </>
                  )}
                  <FormControl
                    className={'patient_search_filter extraTools'}
                    variant="outlined"
                    fullWidth={true}
                    style={{
                      flex: 1,
                      marginTop: 16,
                      marginRight: '2.5%',
                      textAlign: 'right',
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: state.showProvidersAndLocations || isMobile ? 'column' : 'row',
                        justifyContent: 'space-evenly',
                        alignItems: 'center',
                        width: '100%',
                        marginBottom: isMobile ? '0' : '20px',
                      }}
                    >
                      {isMobile ? (
                        <div
                          style={{
                            color: finalTheme.palette.text.primary,
                            fontWeight: 'bold',
                            fontSize: '1.1em',
                            textDecoration: 'underline',
                          }}
                        >
                          Settings
                        </div>
                      ) : (
                        <></>
                      )}
                      {graphs_enabled && (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            color: finalTheme.palette.text.primary,
                            marginBottom: isMobile ? '10px' : '0',
                          }}
                        >
                          <span style={{ marginRight: 8 }}>{graph_layout_mode ? 'Graph Layout' : 'Card Layout'}</span>
                          <Tooltip
                            className={'switchLayoutIcons'}
                            onClick={toggleGraphLayout}
                            placement="right"
                            title={graph_layout_mode ? 'Switch to Card Layout' : 'Switch to Graph Layout'}
                            aria-label={graph_layout_mode ? 'Switch to Card Layout' : 'Switch to Graph Layout'}
                          >
                            <Switch
                              className={classes.switch}
                              style={{
                                cursor: 'pointer',
                                color: graph_layout_mode
                                  ? finalTheme.palette.action.disabled
                                  : finalTheme.palette.action.active,
                              }}
                            />
                          </Tooltip>
                        </div>
                      )}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          color: finalTheme.palette.text.primary,
                          marginBottom: isMobile ? '10px' : '0',
                        }}
                      >
                        <span style={{ marginRight: 8 }}>Toggle Full-Screen</span>
                        <Tooltip
                          onClick={goFullScreen}
                          placement="right"
                          title={'Toggle Full-Screen'}
                          aria-label={'Toggle Full-Screen'}
                        >
                          <AspectRatioIcon
                            className={classes.icon}
                            style={{ cursor: 'pointer', color: finalTheme.palette.action.active, marginBottom: '-4px' }}
                          />
                        </Tooltip>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          color: finalTheme.palette.text.primary,
                          marginBottom: isMobile ? '10px' : '0',
                        }}
                      >
                        <span style={{ marginRight: 8 }}>Auto-Refresh</span>
                        <Tooltip
                          onClick={toggleAutoRefresh}
                          placement="right"
                          title={'Enable Auto-Refresh'}
                          aria-label={'Enable Auto-Refresh'}
                        >
                          <Switch
                            color={auto_refresh ? 'primary' : 'secondary'}
                            checked={auto_refresh}
                            value={auto_refresh}
                          />
                        </Tooltip>
                      </div>
                      {/* 
                                        <Tooltip placement='right' title={"Add New - Coming Soon"} aria-label={"Add New - Disabled"}>
                                            <LibraryAddIcon className={classes.icon} disabled style={{ cursor: 'pointer', color: finalTheme.palette.action.disabled }} />
                                        </Tooltip>
                                        <div style={{ marginLeft: -20 }}>
                                            <Tooltip onClick={handleOpenMoreMenuClick} placement='right' title={"More"} aria-label={"More"}>
                                                <SettingsIcon className={classes.icon} style={{ cursor: 'pointer', color: finalTheme.palette.action.active }} />
                                            </Tooltip>
                                            <Menu
                                                id="dashboard_extras"
                                                anchorEl={anchorElMoreMenu}
                                                open={(anchorElMoreMenu != null) ? true : false}
                                                style={{ marginTop: 30 }}
                                                onClose={closeAllMenus}
                                            >
                                                <MenuItem onClick={() => { window.location = window.location.protocol + '//' + window.location.host + '/' + "availabilities/view_filled.csv" }}>Download 60 Day Report</MenuItem>
                                                {(impersonating) ? <MenuItem><a rel="nofollow" data-method="delete" href={window.location.protocol + '//' + window.location.host + "/stop_impersonating/" + user_id}>Stop Impersonating</a></MenuItem> : <></>}
                                                <MenuItem onClick={resetLayout}>Reset Layout</MenuItem>
                                            </Menu>
                                        </div>
                                        */}
                    </div>
                  </FormControl>
                </div>
              </Toolbar>

              {time_span === 'custom' && (
                <Toolbar
                  style={{ display: 'flex' }}
                  className="custom_expanded"
                >
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <div
                      className={classes.searchBox}
                      style={{ paddingTop: 18, paddingBottom: 18 }}
                    >
                      <FormControl
                        className={'patient_search_box'}
                        style={{ width: '20%', margin: 'auto', marginLeft: '2.5%' }}
                      ></FormControl>
                      <FormControl
                        className={'patient_search_filter'}
                        variant="outlined"
                        fullWidth={true}
                        style={{ width: '25%', marginTop: -5, marginLeft: '2.5%' }}
                      >
                        <DatePicker
                          ref={inputLabelRef3}
                          variant="outlined"
                          label="Start Date"
                          value={timePickerStart}
                          onChange={(val) => handleDateChange(val, 'start')}
                          mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                          format={'MM/dd/yyyy'}
                          maxDate={timePickerStartMax}
                        />
                      </FormControl>
                      <FormControl
                        className={'patient_search_filter'}
                        variant="outlined"
                        fullWidth={true}
                        style={{ width: '25%', marginTop: -5, marginLeft: '2.5%' }}
                      >
                        <DatePicker
                          ref={inputLabelRef4}
                          variant="outlined"
                          label="End Date"
                          value={timePickerEnd}
                          onChange={(val) => handleDateChange(val, 'end')}
                          mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                          format={'MM/dd/yyyy'}
                          minDate={timePickerEndMin}
                          maxDate={timePickerEndMax}
                        />
                      </FormControl>
                      <FormControl
                        className={'patient_search_filter'}
                        variant="outlined"
                        fullWidth={true}
                        style={{
                          width: '20%',
                          marginTop: 16,
                          marginRight: '2.5%',
                          textAlign: 'right',
                          display: 'inline-block',
                        }}
                      ></FormControl>
                    </div>
                  </LocalizationProvider>
                </Toolbar>
              )}
            </AppBar>
            <CssBaseline />
            <Divider />

            <div
              className={graph_layout_mode ? 'container graph_layout' : 'container card_layout'}
              style={{ display: 'none' }}
            >
              {/*<AddCustomCard/>*/}
            </div>

            <GridContextProvider onChange={onChange}>
              <div className={graph_layout_mode ? 'container graph_layout' : 'container card_layout'}>
                <GridDropZone
                  className={
                    isMobile && !graph_layout_mode
                      ? `${classes.dropzone} card_layout`
                      : graph_layout_mode
                      ? 'dropzone top graph_layout'
                      : 'dropzone top card_layout'
                  }
                  id="top"
                  // boxesPerRow={(graph_layout_mode) ? items.top.length : 4}
                  rowHeight={180}
                  // className={`${isMobile ? classes.dropzone : ""} ${(graph_layout_mode) ? "graph_layout" : "card_layout"} ${!isMobile ? "top" : ""}`}
                  boxesPerRow={
                    isMobile ? (graph_layout_mode ? items.top.length : 1) : graph_layout_mode ? items.top.length : 4
                  }
                >
                  {items.top.length > 0 &&
                    items.top.map((item) => (
                      <GridItem
                        className="grid-item"
                        key={item.id}
                        xs={12}
                        sm={6}
                        md={3}
                      >
                        <GraphCard
                          {...item}
                          size={'small'}
                          time_span={time_span}
                          start_time_span={start_time_span}
                          end_time_span={end_time_span}
                          location={location}
                          provider={provider}
                          auto_refresh={auto_refresh}
                          refresh_timer={refresh_timer}
                          created_at={props.created_at}
                          removeCard={removeCard}
                          theme={finalTheme}
                        />
                      </GridItem>
                    ))}
                </GridDropZone>
              </div>

              {graph_layout_mode && (
                <div className="container">
                  <GridDropZone
                    className="dropzone bottom"
                    id="bottom"
                    boxesPerRow={isMobile ? 1 : 3}
                    rowHeight={300}
                  >
                    {items.bottom.length > 0 &&
                      items.bottom.map((item) => (
                        <GridItem
                          width={isMobile ? '100% !important' : '30% !important'}
                          key={item.id}
                          xs={6}
                        >
                          <GraphCard
                            {...item}
                            size={'large'}
                            time_span={time_span}
                            start_time_span={start_time_span}
                            end_time_span={end_time_span}
                            location={location}
                            provider={provider}
                            auto_refresh={auto_refresh}
                            refresh_timer={refresh_timer}
                            created_at={props.created_at}
                            removeCard={removeCard}
                          />
                        </GridItem>
                      ))}
                  </GridDropZone>
                </div>
              )}
            </GridContextProvider>
            {logged_out ? <LoggedOutToast logged_out={true} /> : <></>}
            <CustomMsgToast visible={state.auto_refresh_popup} />
          </main>
          <AnnouncementBar />
        </MuiThemeProvider>
      </Screen>
    </MuiThemeProvider>
  );
};

export default withStyles(styles)(MetricDashboardScreen);
